import { Injectable } from '@angular/core';
import { Params } from "@angular/router";
import { SessionStorageService } from 'ngx-webstorage';



export interface RouteStateSegment {
  path: string;
  /** The matrix parameters associated with a segment */
  parameters: Params;
}

export interface RouteState {
  path?: RouteStateSegment[];
  queryParams?: Params;
  authorities?: string[];
}

@Injectable({
  providedIn: 'root'
})
export class StateStorageService {
  constructor(private $sessionStorage: SessionStorageService) { }

  getPreviousState(): RouteState | null {
    return this.$sessionStorage.retrieve('previousState');
  }

  resetPreviousState(): void {
    this.$sessionStorage.clear('previousState');
  }

  storePreviousState(state: RouteState): void {
    this.$sessionStorage.store('previousState', state);
  }

  resetDestinationState(): void {
    this.$sessionStorage.clear('destinationState');
  }

  storeDestinationState(state: RouteState): void {
    this.$sessionStorage.store('destinationState', state);
  }

  getDestinationState(): RouteState | null {
    return this.$sessionStorage.retrieve('destinationState');
  }
}
